import React, {
  useRef, useEffect, useState,
} from 'react';
import clsx from 'clsx';
import {
  Swiper, SwiperSlide, useSwiper, useSwiperSlide,
} from 'swiper/react';
import 'swiper/css';
import { debounce } from 'lodash';
import AssetDetails from 'modules/feed/components/Feed/AssetDetails';
import Comments from 'modules/feed/components/Feed/Comments';
import Post from 'modules/feed/components/Feed/Post';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as IconArrowLeft } from 'images/icons/arrow-left.svg';
import styles from './PostList.module.scss';
import LoaderEye from '../LoaderEye/LoaderEye';

function PostBlock(props: any) {
  const [commentsVisible, setCommentsVisible] = useState<boolean>(false)
  const [activeAsset, setActiveAsset] = useState<any>()
  const swiperSlide = useSwiperSlide();

  useEffect(() => {
    if (!swiperSlide.isActive) {
      setCommentsVisible(false)
      setActiveAsset(null)
    }
  }, [swiperSlide.isActive])

  const setPanelSize = (ref: HTMLDivElement) => {
    const panelInnerElement = ref
    if (panelInnerElement) {
      const containerElement = ref.parentElement?.parentElement;
      panelInnerElement.style.height = `${containerElement?.offsetHeight}px`;
      if (window.innerWidth <= 1400) {
        panelInnerElement.style.width = `${containerElement?.offsetWidth}px`;
      } else {
        panelInnerElement.style.width = '100%';
      }
    }
  }

  return (
    <div
      className={
        activeAsset || commentsVisible
          ? clsx(styles.panel, styles.openChatOrAssets)
          : styles.panel
      }
    >
      <div
        className={styles.panelInner}
        ref={(refPanelInner) => {
          if (refPanelInner) {
            setPanelSize(refPanelInner)

            window.addEventListener('resize', () => {
              setPanelSize(refPanelInner);
            })
          }
        }}
      >
        {activeAsset ? (
          <AssetDetails
            className={clsx(styles.panelSection, 'swiper-no-swiping')}
            activeAsset={activeAsset.id}
            setActiveAsset={setActiveAsset}
          />
        ) : null}
        <Post
          {...props}
          className={styles.panelSection}
          onShowComments={
            () => {
              setCommentsVisible(true)
              if (window.innerWidth <= 1400) {
                setActiveAsset(null)
              }
            }
          }
          activeAsset={activeAsset}
          setActiveAsset={(asset) => {
            setActiveAsset(asset);
            if (window.innerWidth <= 1400) {
              setCommentsVisible(false)
            }
          }}
        />
        {commentsVisible ? (
          <Comments
            {...props}
            className={clsx(styles.panelSection, 'swiper-no-swiping')}
            onClose={() => setCommentsVisible(false)}
          />
        ) : null}
        <div
          className={styles.mobileModalBackground}
          onClick={() => {
            setCommentsVisible(false)
            setActiveAsset(null)
          }}
        />
      </div>
    </div>
  )
}

function Wheel({ wheelStatus }) {
  const swiper = useSwiper();
  useEffect(() => {
    if (wheelStatus === 'up') {
      swiper.slideNext();
    }
    if (wheelStatus === 'down') {
      swiper.slidePrev();
    }
  }, [wheelStatus])

  return null;
}

type Props = {
  posts: any
  refetch: any
  isLoading: boolean
}

let wheelEventTimeLast = new Date().getTime();
let wheelEventTimeLastForTouchPad = new Date().getTime();

export default function PostList({
  posts,
  refetch,
  isLoading,
}: Props) {
  const feedRef = useRef(null);
  const prevDeltaY = useRef(0);
  const prev2DeltaY = useRef(0);
  const prev3DeltaY = useRef(0);
  const [videoMuted, setVideoMuted] = useState<boolean>(true);
  const [wheelStatus, setWheelStatus] = useState<string | null>(null);
  const { id } = useParams()
  const navigate = useNavigate()

  const setSlideIdtoUrl = () => {
    // @ts-ignore
    const lastPost = feedRef.current?.swiper?.activeIndex;
    const activeSlide = document.querySelector(`.swiper-slide:nth-child(${(lastPost + 1) || 1})`);
    // @ts-ignore
    const activeId = activeSlide?.dataset?.id;

    const basePath = '/tradingPlatforms';
    const finalPath = activeId ? `${basePath}/${activeId}` : basePath;

    window.history.replaceState(null, '', finalPath)
  }

  const onSlideChange = () => {
    setSlideIdtoUrl()
  }

  // Отсутствует динамическая ссылка (id) первого видео
  useEffect(() => {
    if (!id && posts) { // @ts-ignore
      setSlideIdtoUrl()
    }
  }, [posts])

  const debouncedOnWheel = debounce((status) => {
    setWheelStatus(status);
    setTimeout(() => {
      setWheelStatus(null);
    }, 300)
  }, 310, {
    leading: true,
    trailing: false,
  })

  const OnWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    const { deltaY } = event;

    const currentTime = new Date().getTime();

    if (currentTime - wheelEventTimeLast > 500) {
      if (deltaY > 0) {
        debouncedOnWheel('up');
      } else {
        debouncedOnWheel('down');
      }
      wheelEventTimeLastForTouchPad = currentTime;
    } else if (currentTime - wheelEventTimeLastForTouchPad > 500) {
      if (
        (deltaY > 0 && deltaY > prevDeltaY.current
          && prevDeltaY.current > prev2DeltaY.current && prev2DeltaY.current > prev3DeltaY.current)
        || (deltaY < 0 && deltaY < prevDeltaY.current
          && prevDeltaY.current < prev2DeltaY.current && prev2DeltaY.current < prev3DeltaY.current)
      ) {
        debouncedOnWheel(deltaY > 0 ? 'up' : 'down');
      }
      prev3DeltaY.current = prev2DeltaY.current;
      prev2DeltaY.current = prevDeltaY.current;
      prevDeltaY.current = deltaY;
    }

    wheelEventTimeLast = currentTime;
  }

  useEffect(() => {
    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    if (!isFirefox) {
      const autoplayTestContent = document.createElement('video');

      autoplayTestContent.src = 'data:video/mp4;base64,AAAAFGZ0eXBNU05WAAACAE1TTlYAAAOUbW9vdgAAAGxtdmhkAAAAAM9ghv7PYIb+AAACWAAACu8AAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAnh0cmFrAAAAXHRraGQAAAAHz2CG/s9ghv4AAAABAAAAAAAACu8AAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAFAAAAA4AAAAAAHgbWRpYQAAACBtZGhkAAAAAM9ghv7PYIb+AAALuAAANq8AAAAAAAAAIWhkbHIAAAAAbWhscnZpZGVBVlMgAAAAAAABAB4AAAABl21pbmYAAAAUdm1oZAAAAAAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAVdzdGJsAAAAp3N0c2QAAAAAAAAAAQAAAJdhdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAFAAOABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAAEmNvbHJuY2xjAAEAAQABAAAAL2F2Y0MBTUAz/+EAGGdNQDOadCk/LgIgAAADACAAAAMA0eMGVAEABGjuPIAAAAAYc3R0cwAAAAAAAAABAAAADgAAA+gAAAAUc3RzcwAAAAAAAAABAAAAAQAAABxzdHNjAAAAAAAAAAEAAAABAAAADgAAAAEAAABMc3RzegAAAAAAAAAAAAAADgAAAE8AAAAOAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA4AAAAOAAAAFHN0Y28AAAAAAAAAAQAAA7AAAAA0dXVpZFVTTVQh0k/Ou4hpXPrJx0AAAAAcTVREVAABABIAAAAKVcQAAAAAAAEAAAAAAAAAqHV1aWRVU01UIdJPzruIaVz6ycdAAAAAkE1URFQABAAMAAAAC1XEAAACHAAeAAAABBXHAAEAQQBWAFMAIABNAGUAZABpAGEAAAAqAAAAASoOAAEAZABlAHQAZQBjAHQAXwBhAHUAdABvAHAAbABhAHkAAAAyAAAAA1XEAAEAMgAwADAANQBtAGUALwAwADcALwAwADYAMAA2ACAAMwA6ADUAOgAwAAABA21kYXQAAAAYZ01AM5p0KT8uAiAAAAMAIAAAAwDR4wZUAAAABGjuPIAAAAAnZYiAIAAR//eBLT+oL1eA2Nlb/edvwWZflzEVLlhlXtJvSAEGRA3ZAAAACkGaAQCyJ/8AFBAAAAAJQZoCATP/AOmBAAAACUGaAwGz/wDpgAAAAAlBmgQCM/8A6YEAAAAJQZoFArP/AOmBAAAACUGaBgMz/wDpgQAAAAlBmgcDs/8A6YEAAAAJQZoIBDP/AOmAAAAACUGaCQSz/wDpgAAAAAlBmgoFM/8A6YEAAAAJQZoLBbP/AOmAAAAACkGaDAYyJ/8AFBAAAAAKQZoNBrIv/4cMeQ==';
      autoplayTestContent.id = 'base64_test_video';
      autoplayTestContent.autoplay = true;
      autoplayTestContent.playsInline = true;
      autoplayTestContent.style.position = 'fixed';
      autoplayTestContent.style.left = '5000px';
      if (autoplayTestContent.muted) {
        autoplayTestContent?.play()
      }

      document.getElementsByTagName('body')[0].appendChild(autoplayTestContent);

      let iteration = 0;

      const interval = setInterval(() => {
        if (!autoplayTestContent?.paused && videoMuted && iteration) {
          setVideoMuted(false);
        }

        iteration += 1;

        if (iteration === 5 || (!autoplayTestContent?.paused && !videoMuted)) {
          clearInterval(interval);
          document.body.removeChild(autoplayTestContent);
        }
      }, 200);
    }
    // @ts-ignore
    if (navigator?.getAutoplayPolicy && navigator.getAutoplayPolicy('mediaelement') === 'allowed' && isFirefox) {
      setVideoMuted(false)
    }
  }, [])

  const handleKeyDownUp = (event) => {
    if (event.key === 'ArrowDown') {
      // @ts-ignore
      feedRef.current?.swiper?.slideNext();
    } else if (event.key === 'ArrowUp') {
      // @ts-ignore
      feedRef.current?.swiper?.slidePrev();
    }
  };

  useEffect(() => {
    if (posts) {
      document.addEventListener('keydown', handleKeyDownUp);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDownUp);
    };
  }, [posts]);

  if (!posts || posts.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.posts}>
          <div className={styles.postContainer}>
            <div className={styles.panel}>
              {isLoading ? (
                <div className={styles.panelInner}>
                  <div className={clsx(
                    styles.panelSection,
                    styles.panelSection_placeholder,
                  )}
                  >
                    <LoaderEye className={styles.loader} />
                  </div>
                </div>
              ) : isLoading && (
                <div className={styles.panelInner}>
                  <div className={clsx(
                    styles.panelSection,
                    styles.panelSection_placeholder,
                    styles.panelSection_noBg,
                  )}
                  >
                    <p className={styles.nothingFound}>Nothing found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const handleMuted = (value) => {
    setVideoMuted(value)
  }

  return (
    <div
      className={styles.container}
      onWheel={(event) => {
        event.stopPropagation()
        OnWheel(event)
      }}
    >
      <Swiper
        className={styles.posts}
        ref={feedRef}
        direction="vertical"
        slidesPerView={1}
        centeredSlides
        spaceBetween={0}
        speed={200} // Added speed for smooth scrolling
        effect="slide"
        onSlideChange={onSlideChange}
        touchStartPreventDefault={false}
        breakpoints={{
          501: {
            slidesPerView: 'auto',
            spaceBetween: 10,
            autoHeight: true,
          },
          1401: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            autoHeight: true,
          },
        }}
      >
        <Wheel wheelStatus={wheelStatus} />
        {posts?.length ? (posts.map((post: any, idx: number) => (
          <SwiperSlide key={post?.id} className={styles.postContainer} data-id={post?.id}>

            {({ isActive, isNext, isPrev }) => ( // eslint-disable-line
              isActive || isNext || isPrev ? (
                <PostBlock
                  data={post.data = post} // eslint-disable-line
                  refresh={refetch}
                  videoMuted={videoMuted}
                  onVideoMuted={handleMuted}
                  idx={idx}
                />
              ) : (
                <div className={styles.panel} />
              )
            )}
          </SwiperSlide>
        ))) : null}
      </Swiper>
    </div>
  )
}
